import { FunctionComponent, MouseEvent, PropsWithChildren, useState } from 'react';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { HoverActionButton } from '@cbridge-tools/button';

export const NavigationItemMenu: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuClick = (event: MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    handleClose();
  };

  return (
    <div>
      <HoverActionButton
        aria-label={'context menu'}
        id={'menu-button'}
        aria-controls={open ? 'context-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup={'true'}
        onClick={handleOpen}
      >
        <MoreVertIcon fontSize={'medium'} />
      </HoverActionButton>
      <Menu
        id={'context-menu'}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleMenuClick}
        slotProps={{
          list: {
            'aria-labelledby': 'menu-button',
          },
        }}
      >
        {children}
      </Menu>
    </div>
  );
};
